// redux/reducers/journeyReducer.js
import { 
  FETCH_JOURNEY_DATA,
  TOGGLE_LOADING, 
  DELETE_JOURNEY_DATA,
  FETCH_JOURNEY_DETAIL,
  SET_CURRENT_PAGE,
  SET_ITEMS_PER_PAGE,
  SET_SEARCH_TERM,
  SET_FILTERS,
  CLEAR_FILTERS,
  UPDATE_PAGINATION_TOTALS,
  SET_SEGMENT_CURRENT_PAGE,
  SET_SEGMENT_ITEMS_PER_PAGE,
  UPDATE_SEGMENT_PAGINATION_TOTALS,
  JOURNEY_CREATE,
  FETCH_SEGMENTS_REQUEST,
  FETCH_SEGMENTS_SUCCESS,
  FETCH_SEGMENTS_FAILURE,
  GET_SEGMENT_REQUEST,
  GET_SEGMENT_SUCCESS,
  GET_SEGMENT_FAILURE,
  CREATE_SEGMENT_REQUEST,
  CREATE_SEGMENT_SUCCESS,
  CREATE_SEGMENT_FAILURE,
  SCHEDULE_JOURNEY_REQUEST,
  SCHEDULE_JOURNEY_SUCCESS,
  SCHEDULE_JOURNEY_FAILURE,
  FETCH_MASTER_LIST_REQUEST,
  FETCH_MASTER_LIST_SUCCESS,
  FETCH_MASTER_LIST_FAILURE,
  JOURNEY_UPDATE_REQUEST,
  JOURNEY_UPDATE_SUCCESS,
  JOURNEY_UPDATE_FAILURE,
  JOURNEY_CREATE_REQUEST,
  JOURNEY_CREATE_SUCCESS,
  JOURNEY_CREATE_FAILURE,
  FETCH_JOURNEY_PARTNER_CATEGORIES,
  COPY_JOURNEY_REQUEST,
  COPY_JOURNEY_SUCCESS,
  COPY_JOURNEY_FAILURE,
  COUNT_USERS_REQUEST,
  COUNT_USERS_SUCCESS,
  COUNT_USERS_FAILURE,
  RESET_USER_COUNT,
  FILTER_DROPDOWN_DATA,
  FILTER_DROPDOWN_DATA_SUCCESS,
  FILTER_DROPDOWN_DATA_FAILURE,
  WHATSAPP_TEMPLATE_UPDATE_REQUEST,
  WHATSAPP_TEMPLATE_UPDATE_SUCCESS,
  WHATSAPP_TEMPLATE_UPDATE_FAILURE,
  NOTIFICATION_DETAIL_LIST_REQUEST,
  NOTIFICATION_DETAIL_LIST_SUCCESS,
  NOTIFICATION_DETAIL_LIST_FAILURE,
  DELETE_SEGMENT_DATA
} from "../../constants/ActionTypes";

const initialState = {
  loading: false,
  journey_data: [],
  all_journey_data: [], // Store all data for client-side pagination
  journey_detail: [],
  notification_details: [],
  notification_details_loading: false,
  segments: [],
  segments_loading: false,
  segment: null,
  segment_loading: false,
  segment_error: null,
  schedule_loading: false,
  master_list: [],
  master_list_loading: false,
  partner_categories: [],
  copy_journey_success: false, // Track copy journey success
  user_count: 0,
  count_loading: false,
  count_error: null,
  filter_dropdowns: {},
  filter_dropdowns_loading: false,
  filter_dropdowns_error: null,
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0
  },
  segment_pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0
  },
  searchTerm: '',
  filters: {
    segment: '',
    status: ''
  }
};

const journeyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case NOTIFICATION_DETAIL_LIST_REQUEST:
      return { ...state, notification_details_loading: true };
    case NOTIFICATION_DETAIL_LIST_SUCCESS:
      return { ...state, notification_details_loading: false, notification_details: payload };
    case NOTIFICATION_DETAIL_LIST_FAILURE:
      return { ...state, notification_details_loading: false };
    case FETCH_JOURNEY_DATA:
      return { 
        ...state, 
        journey_data: payload.data || payload,
        all_journey_data: payload.allData || payload.data || payload, // Store all data
        pagination: {
          currentPage: payload.pagination?.currentPage || 1,
          totalPages: payload.pagination?.totalPages || 1,
          totalItems: payload.pagination?.totalRecords || (payload.data ? payload.data.length : payload.length),
          itemsPerPage: payload.pagination?.limit || 10
        }
      };

    case FETCH_JOURNEY_DETAIL:
      return { ...state, journey_detail: payload };

    case DELETE_JOURNEY_DATA:
      const updatedJourneys = state.journey_data.filter(journey => journey.id !== payload);
      return { 
        ...state, 
        journey_data: updatedJourneys,
        pagination: {
          ...state.pagination,
          totalItems: updatedJourneys.length,
          totalPages: Math.ceil(updatedJourneys.length / state.pagination.itemsPerPage)
        }
      };

      
    case TOGGLE_LOADING:
      return { ...state, loading: payload };

    case JOURNEY_UPDATE_REQUEST:
      return { ...state, loading: true };

    case JOURNEY_UPDATE_SUCCESS:
      return { ...state, loading: false };

    case JOURNEY_UPDATE_FAILURE:
      return { ...state, loading: false };

    case JOURNEY_CREATE_REQUEST:
      return { ...state, loading: true };

    case JOURNEY_CREATE_SUCCESS:
      return { ...state, loading: false };

    case JOURNEY_CREATE_FAILURE:
      return { ...state, loading: false };

    case SET_CURRENT_PAGE:
      return { 
        ...state, 
        pagination: { ...state.pagination, currentPage: payload }
      };

    case SET_ITEMS_PER_PAGE:
      return { 
        ...state, 
        pagination: { 
          ...state.pagination, 
          itemsPerPage: payload,
          currentPage: 1 // Reset to first page when changing items per page
        }
      };

    case SET_SEARCH_TERM:
      return { 
        ...state, 
        searchTerm: payload,
        pagination: { ...state.pagination, currentPage: 1 } // Reset to first page when searching
      };

    case SET_FILTERS:
      return { 
        ...state, 
        filters: { ...state.filters, ...payload },
        pagination: { ...state.pagination, currentPage: 1 } // Reset to first page when filtering
      };

    case CLEAR_FILTERS:
      return { 
        ...state, 
        filters: { segment: '', status: '' },
        searchTerm: '',
        pagination: { ...state.pagination, currentPage: 1 }
      };

    case UPDATE_PAGINATION_TOTALS:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          totalItems: payload.totalItems,
          totalPages: payload.totalPages
        }
      };

    // Segment Pagination Cases
    case SET_SEGMENT_CURRENT_PAGE:
      return {
        ...state,
        segment_pagination: {
          ...state.segment_pagination,
          currentPage: payload,
        },
      };
    
    case SET_SEGMENT_ITEMS_PER_PAGE:
      return {
        ...state,
        segment_pagination: {
          ...state.segment_pagination,
          itemsPerPage: payload,
          currentPage: 1, // Reset to first page when changing items per page
        },
      };
    
    case UPDATE_SEGMENT_PAGINATION_TOTALS:
      return {
        ...state,
        segment_pagination: {
          ...state.segment_pagination,
          totalItems: payload.totalItems,
          totalPages: payload.totalPages
        }
      };

    // Segment cases
    case FETCH_SEGMENTS_REQUEST:
      return { ...state, segments_loading: true };

    case FETCH_SEGMENTS_SUCCESS:
      return { 
        ...state, 
        segments: payload,
        segments_loading: false 
      };

    case FETCH_SEGMENTS_FAILURE:
      return { ...state, segments_loading: false };

    case GET_SEGMENT_REQUEST:
      console.log("🔄 GET_SEGMENT_REQUEST - Setting loading to true");
      return { ...state, segment_loading: true, segment_error: null };

    case GET_SEGMENT_SUCCESS:
      console.log("✅ GET_SEGMENT_SUCCESS - Segment data stored:", payload);
      return { 
        ...state, 
        segment: payload,
        segment_loading: false,
        segment_error: null
      };

    case GET_SEGMENT_FAILURE:
      console.log("❌ GET_SEGMENT_FAILURE - Error:", payload);
      return { ...state, segment_loading: false, segment_error: payload };

    case CREATE_SEGMENT_REQUEST:
      return { ...state, segments_loading: true };

    case CREATE_SEGMENT_SUCCESS:
      return { 
        ...state, 
        segments: [...state.segments, payload],
        segments_loading: false 
      };

    case CREATE_SEGMENT_FAILURE:
      return { ...state, segments_loading: false };


    // Delete segment from list
    case DELETE_SEGMENT_DATA:
      return {
        ...state,
        segments: state.segments.filter(segment => segment.id !== payload)
      };

    // Schedule Journey cases
    case SCHEDULE_JOURNEY_REQUEST:
      return { ...state, schedule_loading: true };

    case SCHEDULE_JOURNEY_SUCCESS:
      return { 
        ...state, 
        schedule_loading: false 
      };

    case SCHEDULE_JOURNEY_FAILURE:
      return { ...state, schedule_loading: false };

    // Master List cases
    case FETCH_MASTER_LIST_REQUEST:
      return { ...state, master_list_loading: true };

    case FETCH_MASTER_LIST_SUCCESS:
      return { 
        ...state, 
        master_list: payload, 
        master_list_loading: false 
      };

    case FETCH_MASTER_LIST_FAILURE:
      return { ...state, master_list_loading: false };

    // Partner Categories case
    case FETCH_JOURNEY_PARTNER_CATEGORIES:
      return { 
        ...state, 
        partner_categories: payload 
      };

      case COPY_JOURNEY_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case COPY_JOURNEY_SUCCESS:
        return {
          ...state,
          loading: false,
          copy_journey_success: true,
          // Don't modify journey_data here - let the listing refresh handle it
        };
      case COPY_JOURNEY_FAILURE:
        return {
          ...state,
          loading: false,
          error: payload,
        };
      
      case 'RESET_COPY_JOURNEY_SUCCESS':
        return {
          ...state,
          copy_journey_success: false,
        };

      // Count Users Cases
      case COUNT_USERS_REQUEST:
        return {
          ...state,
          count_loading: true,
          count_error: null,
        };
      
      case COUNT_USERS_SUCCESS:
        return {
          ...state,
          count_loading: false,
          user_count: payload,
          count_error: null,
        };
      
      case COUNT_USERS_FAILURE:
        return {
          ...state,
          count_loading: false,
          count_error: payload,
        };
      
      case RESET_USER_COUNT:
        return {
          ...state,
          user_count: 0,
          count_error: null,
        };
      
      // Filter Dropdowns
      case FILTER_DROPDOWN_DATA:
        return {
          ...state,
          filter_dropdowns_loading: true,
          filter_dropdowns_error: null,
        };
      case FILTER_DROPDOWN_DATA_SUCCESS:
        return {
          ...state,
          filter_dropdowns_loading: false,
          filter_dropdowns: payload,
        };
      case FILTER_DROPDOWN_DATA_FAILURE:
        return {
          ...state,
          filter_dropdowns_loading: false,
          filter_dropdowns_error: payload,
        };
      
      case 'CLEAR_COPY_JOURNEY_ERROR':
        return {
          ...state,
          error: null,
        };
      
      case WHATSAPP_TEMPLATE_UPDATE_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case WHATSAPP_TEMPLATE_UPDATE_SUCCESS:
        return {
          ...state,
          loading: false,
        };
      case WHATSAPP_TEMPLATE_UPDATE_FAILURE:
        return {
          ...state,
          loading: false,
        };


    default:
      return state;
  }
};

export default journeyReducer;
